module.exports = __webpack_public_path__ + "793b06f7b478375546d827b911630dda.jpg";